<template>
  <main class="main  page-inside">
    <div class="main-wrapper">
      <section class="section hero-section product-list-section">
        <div class="wrapper">
          <router-link to="/home" class="back"><span>Back to main</span></router-link>
          <div class="title">Fresh skins</div>
          <div class="list products">
            <div class="item" v-for="(item, index) in $parent.newArrivals" :key="index">
              <ProductCard :item="item" :tag="'New'" :addToCartChosenItem="addToCartChosenItem" :sliderIsClickble="true" @goToProduct="goToProduct" :currency="currency" @addToCart="addToCart"/>
            </div>
          </div>
        </div>
      </section>
    </div>
  </main>
</template>
<script>
import ProductCard from '../components/ProductCard.vue'

export default {
  name: 'NewArrivals',
  props: ['addToCartChosenItem', 'currency'],
  components: {
    ProductCard
  },
  data: function() {
    return {
      imgDomain: '',
    }
  },
  methods: {
    addToCart(item) {
      this.$emit("addToCart", item.id, item.item_type);
    },
    goToProduct(item) {
      this.$emit('goToProduct', item)
    }
  },
  mounted() {
    this.imgDomain = process.env.VUE_APP_STATIC_DOMAIN;
  }
}
</script>